
<v-autocomplete
    v-if="items && preferences && msd"
    auto-select-first
    autocomplete  = "off"
    autocorrect   = "off"
    autocapitalize= "off"
    spellcheck    = "false"
    :clearable    = "clearable"
    :label        = "label"
    :items        = "items"
    :rules        = "rules"
    :prepend-icon = "prependIcon"
    :hide-details = "hideDetails"
    item-value    = "id"
    item-text     = "name"
    v-model       = "selected"
    :readonly     = "readonly"
    :disabled     = "readonly"
    @change       = "onChange"
/>
